export default (theme) => ({
  sendButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 24,
  },
  logoWrapper: {
    margin: '0 auto',
    marginTop: 30,
    marginBottom: 34,
  },
  separator: {
    width: '100%',
    height: 2,
    backgroundColor: theme.palette.background.main,
  },
  forgot: {
    marginTop: 28,
    marginBottom: 16,
    textAlign: 'center',
  },
  forgotDescription: {},
  loginWrapper: {
    marginTop: 12,
  },
});
